import * as Menu from "src/components/ui-components/MenuPanel/MenuPanel";
import { IconButton } from "src/components/ui-components/Button/IconButton";
import { IconPencilLine } from "src/components/ui-components/Icons/IconPencilLine";
import { IconCheckmark } from "src/components/ui-components/Icons/IconCheckmark";
import { IconCross } from "src/components/ui-components/Icons/IconCross";

import { useState } from "react";

export function MenuItemFreeformOption(props: {
  value: string;
  onChange: (value: string) => void;
  onRemove: () => void;
}) {
  const { value, onChange, onRemove } = props;

  const [isEditing, setIsEditing] = useState(value === "");
  const [editValue, setEditValue] = useState(value);

  function startEditing() {
    setIsEditing(true);
  }

  function stopEditing() {
    setIsEditing(false);

    if (editValue === "") {
      onRemove();
    } else {
      onChange(editValue);
    }
  }

  if (isEditing) {
    return (
      <Menu.ItemLabel
        nestedButtonsOrLinks={
          <IconButton size="XS" theme="ghost" onClick={stopEditing}>
            <IconCheckmark />
          </IconButton>
        }
      >
        <input
          type="text"
          autoFocus
          value={editValue}
          onChange={(event) => setEditValue(event.target.value)}
          onBlur={stopEditing}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.stopPropagation();
              stopEditing();
            }
          }}
        />
      </Menu.ItemLabel>
    );
  }

  return (
    <Menu.ItemButton
      active
      onClick={startEditing}
      nestedButtonsOrLinks={
        <>
          <IconButton size="XS" theme="ghost" onClick={onRemove}>
            <IconCross />
          </IconButton>
          <IconButton size="XS" theme="ghost" onClick={startEditing}>
            <IconPencilLine />
          </IconButton>
        </>
      }
    >
      <Menu.Text>{value}</Menu.Text>
    </Menu.ItemButton>
  );
}
